import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { CheckCircle, Star, Users, Shield } from "lucide-react";

const Hero = () => {
  return (
    <section className="py-20 px-4 bg-gradient-to-br from-background via-secondary/30 to-background">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <Badge variant="secondary" className="mb-6 px-4 py-2">
            <Star className="w-4 h-4 mr-2 text-primary" />
            Independent EMR Research Platform
          </Badge>
          
          <h1 className="text-4xl md:text-6xl font-bold text-foreground mb-6 leading-tight">
            Find the Perfect
            <span className="text-primary block mt-2">
              Behavioral EMR
            </span>
            for Your Organization
          </h1>
          
          <p className="text-xl text-muted-foreground mb-8 max-w-3xl mx-auto leading-relaxed">
            Compare top-rated behavioral health EMR systems with comprehensive analysis, 
            detailed features comparison, and expert recommendations to make the right choice for your organization.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <Button size="lg" className="px-8 py-6 text-lg" asChild>
              <a href="/get-recommendation">Get Free EMR Recommendation</a>
            </Button>
            <Button variant="outline" size="lg" className="px-8 py-6 text-lg" asChild>
              <a href="/comparisons">Compare EMRs</a>
            </Button>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="flex items-center justify-center space-x-3 p-4 rounded-lg bg-card border border-border">
              <CheckCircle className="w-6 h-6 text-success" />
              <span className="text-sm font-medium">HIPAA Compliant</span>
            </div>
            
            <div className="flex items-center justify-center space-x-3 p-4 rounded-lg bg-card border border-border">
              <Users className="w-6 h-6 text-primary" />
              <span className="text-sm font-medium">Expert Analysis</span>
            </div>
            
            <div className="flex items-center justify-center space-x-3 p-4 rounded-lg bg-card border border-border">
              <Shield className="w-6 h-6 text-accent" />
              <span className="text-sm font-medium">Expert Verified</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;